// HOC that mounts the reporting-state URL sync + auto-select + theme +
// page-title effects above every routed view. Replaces the old
// ReportingProvider wrapper — state now lives in Redux so consumers
// read via `useReportingState()` without a context boundary.
import type { ComponentType, FC } from 'react'
import {
  useReportingAutoSelect,
  useReportingBodyTheme,
  useReportingPageTitle,
  useReportingUrlSync
} from './reporting-state'

export function withReportingState<P extends object>(
  Component: ComponentType<P>
) {
  const Wrapped: FC<P> = (props) => {
    useReportingUrlSync()
    useReportingAutoSelect()
    useReportingBodyTheme()
    useReportingPageTitle()
    return <Component {...props} />
  }
  Wrapped.displayName = `withReportingState(${Component.displayName || Component.name})`
  return Wrapped
}
